module.exports = __webpack_public_path__ + "brandon_med_it-webfont.9a9d985b291d2c7bfda3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_med_it-webfont.woff
// module id = 945
// module chunks = 7